import React from 'react'
import { Box, Text, Flex, Hide } from 'pcln-design-system'
import PropTypes from 'prop-types'
import MediaQueryMatch from '@pcln/media-query-match'

const PerPersonText = () => (
  <Text color='text.light' fontSize={0} textAlign='center'>
    per person
  </Text>
)

const getFontSize = (isDepartureSummary) =>
  isDepartureSummary ? ['16px', '16px', '20px', '24px'] : ['20px', '24px']

const DisplayPrice = ({
  dollars,
  cents,
  ml,
  showPerPersonText,
  dollar,
  color,
  isResponsive,
  tripType,
  prefaceText,
  showInline,
  fontSize,
  shouldPriceRoundUp,
  isMultiDestination,
  isDepartureSummary,
}) => {
  const amountBeforeDecimal = dollars || dollar
  const amountAfterDecimal = cents ? amountBeforeDecimal + '.' + cents : amountBeforeDecimal
  const amount = shouldPriceRoundUp ? Math.ceil(+amountAfterDecimal) : amountBeforeDecimal
  return (
    <Box ml={ml} data-autobot-element-id='GREEN_DISPLAY_PRICE'>
      <Text color={color} data-testid='display-price'>
        <Flex justifyContent={!isDepartureSummary && isMultiDestination ? 'center' : 'flex-end'}>
          {prefaceText && (
            <Text fontSize={isResponsive ? ['18px', '22px'] : 3} mr={[1, 2]}>
              {prefaceText}
            </Text>
          )}
          <Text fontSize={fontSize.small} value='$' bold>
            $
          </Text>
          <Text
            lineHeight={1}
            bold
            fontSize={isResponsive ? getFontSize(isDepartureSummary) : fontSize.large}
          >
            {amount}
          </Text>
          {!shouldPriceRoundUp && cents && (
            <Hide xs={isResponsive}>
              <Text fontSize={fontSize.small}>{`.${cents}`}</Text>
            </Hide>
          )}

          {
            /* istanbul ignore next */
            showPerPersonText && showInline && (
              <MediaQueryMatch minWidth='md' ignore={false}>
                <Flex alignItems={'flex-end'} ml={'5px'} mb={'4px'}>
                  <PerPersonText />
                </Flex>
              </MediaQueryMatch>
            )
          }
        </Flex>
      </Text>

      {showPerPersonText && showInline && (
        <MediaQueryMatch maxWidth='md' ignore={false}>
          <Flex alignItems={'flex-end'} ml={'5px'} mb={'4px'}>
            <PerPersonText />
          </Flex>
        </MediaQueryMatch>
      )}
      {showPerPersonText && !showInline && <PerPersonText />}
      {tripType && (
        <Text color='text.light' fontSize={0} textAlign='center'>
          {tripType}
        </Text>
      )}
    </Box>
  )
}

DisplayPrice.propTypes = {
  dollars: PropTypes.string,
  dollar: PropTypes.string,
  cents: PropTypes.string,
  prefaceText: PropTypes.string,
  ml: PropTypes.string,
  isDepartureSummary: PropTypes.bool,

  /** Show 'per person' text in ExpressDealAltOptionsCard */
  showPerPersonText: PropTypes.bool,

  /** Show 'round trip' or 'one way' text in ExpressDealAltOptionsCard */
  tripType: PropTypes.string,

  /** Font sizes for dollar, cents, and currency symbol */
  fontSize: PropTypes.shape({
    large: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    small: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  color: PropTypes.string,
  isResponsive: PropTypes.bool,
  showInline: PropTypes.bool,
  shouldPriceRoundUp: PropTypes.bool,
  isMultiDestination: PropTypes.bool,
}

DisplayPrice.defaultProps = {
  fontSize: { large: 4, small: 1 },
  shouldPriceRoundUp: true,
  color: 'success.base',
  isMultiDestination: false,
}

export default DisplayPrice
